import Frequency from './Frequency'

export default Frequency
